import { useRef, useState } from "react";
import { PlayCircleOutlined } from "@ant-design/icons";

const VideoComponent = ({ post }: any) => {
  const [isPlayVideo, setIsPlayVideo] = useState(false);
  const vidRef = useRef<any>();

  const playVideo = () => {
    if (!isPlayVideo) {
      vidRef.current.play();
    } else {
      vidRef.current.pause();
    }
    setIsPlayVideo(!isPlayVideo);
  };
  return (
    <>
      <video
        ref={vidRef}
        controls={isPlayVideo}
        key={post.id}
        style={{ width: "100%" }}
        className="item video_post mb-0"
        onClick={playVideo}
      >
        <source
          src={
            post?.file && typeof post?.file === "object"
              ? URL.createObjectURL(post?.file)
              : process.env.REACT_APP_STORAGE_URL + post?.file
          }
          type="video/webm"
        />
      </video>
      {/*    {!isPlayVideo && (
        <div className="content">
          <button className="play" onClick={playVideo}>
            <PlayCircleOutlined />
          </button>
        </div>
      )} */}
    </>
  );
};

export default VideoComponent;
